import { render, staticRenderFns } from "./RolesAndPermissionsIndex.vue?vue&type=template&id=6f744c8c&scoped=true"
import script from "./RolesAndPermissionsIndex.vue?vue&type=script&lang=js"
export * from "./RolesAndPermissionsIndex.vue?vue&type=script&lang=js"
import style0 from "./RolesAndPermissionsIndex.vue?vue&type=style&index=0&id=6f744c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f744c8c",
  null
  
)

export default component.exports